<mat-card class="research-paper-card" [@paperChange]="animationState">
  <mat-card-header>
    <mat-card-title
      [routerLink]="['/project', paper().projectId, 'paper', paper().id]"
      [queryParams]="linkSelectedTab() > 0 ? { tab: linkSelectedTab() } : {}"
      [class.clickable]="!disablePapersDialog()"
     >{{ paper().title }}
    </mat-card-title>

    @if (editable() && isSelfCreated()) {
      <button mat-icon-button (click)="openUpdateDialog()" class="change-btn">
        <mat-icon>settings</mat-icon>
      </button>
    }
  </mat-card-header>

  <mat-card-content>
    <div class="info">
      <mat-icon>menu_book</mat-icon>
      <span>{{ paper().venue }} - {{ paper().year }} </span>
    </div>

    <div class="info">
      <mat-icon>lightbulb</mat-icon>
      <span> <b>{{ paper().citationCount || 0 }}</b> Citations</span>
      <span> <b>{{ paper().referenceCount || 0 }}</b> References</span>
    </div>

    @if (!hideAuthor()) {
      <div class="info">
        <mat-icon>group</mat-icon>
        <span>{{ paper().authors }}</span>
      </div>
    }
    @if (!hideChips()) {
      <mat-chip-set>
        @if (paper().isOpenAccess) {
          <mat-chip class="open-access">
            <mat-icon matChipAvatar>lock_open</mat-icon>
            <span>Open Access</span>
          </mat-chip>
        }
        @if (!paper().abstractText) {
          <mat-chip class="screening--no-file">
            <mat-icon matChipAvatar>article</mat-icon>
            <span>No abstract found</span>
          </mat-chip>
        }
        @if (getPDFUrl()) {
          @if (editable()) {
            <a [href]="getPDFUrl()" target="_blank" class="open-access--link">
              <mat-chip class="open-access">
                <mat-icon matChipAvatar>picture_as_pdf</mat-icon>
                <span>PDF</span>
              </mat-chip>
            </a>
          } @else {
            <mat-chip class="open-access">
              <mat-icon matChipAvatar>picture_as_pdf</mat-icon>
              <span>PDF</span>
            </mat-chip>
          }
        }
        @if (paper().url) {
          <a [href]="paper().url" target="_blank" class="open-access--link">
            <mat-chip class="open-access">
              <mat-icon matChipAvatar>link</mat-icon>
              <span>Find the paper here</span>
            </mat-chip>
          </a>
        }

        @if (paper().latestScreeningRun) {
          @if (paper().latestScreeningRun!.manuelOverrideScreeningOne !== null || (paper().latestScreeningRun!.screeningOne && paper().latestScreeningRun!.screeningOne!.audited)) {
            <span class="spacer"></span>
            <mat-chip class="screening"
                      [class.screening--success]="paper().latestScreeningRun!.screeningOne && paper().latestScreeningRun!.screeningOne!.passed"
                      [class.screening--failed]="paper().latestScreeningRun!.screeningOne &&  !paper().latestScreeningRun!.screeningOne!.passed"
                      [class.screening--manuel-sucess]="paper().latestScreeningRun!.manuelOverrideScreeningOne !== null && paper().latestScreeningRun!.manuelOverrideScreeningOne"
                      [class.screening--manuel-failed]="paper().latestScreeningRun!.manuelOverrideScreeningOne !== null && !paper().latestScreeningRun!.manuelOverrideScreeningOne"
                      (click)="viewResults(true)"
            >
            <span>Title/Abstract Screening:
              @if (paper().latestScreeningRun!.manuelOverrideScreeningOne !== null) {
                @if (paper().latestScreeningRun!.manuelOverrideScreeningOne) {
                  Manual passed
                } @else {
                  Manual failed
                }
                @if (paper().latestScreeningRun!.screeningOne) {
                  /
                  @if (paper().latestScreeningRun!.screeningOne!.passed) {
                    Academate Passed
                  } @else {
                    Academate Failed
                  }
                }
              } @else if (paper().latestScreeningRun!.screeningOne) {
                @if (paper().latestScreeningRun!.screeningOne!.passed) {
                  Passed
                } @else {
                  Failed
                }
              }
            </span>
            </mat-chip>
          }

          @if (paper().latestScreeningRun!.manuelOverrideScreeningTwo !== null || (paper().latestScreeningRun!.screeningTwo && paper().latestScreeningRun!.screeningTwo!.audited)) {
            <mat-chip class="screening"
                      [class.screening--success]="paper().latestScreeningRun!.screeningTwo && paper().latestScreeningRun!.screeningTwo!.passed"
                      [class.screening--failed]="paper().latestScreeningRun!.screeningTwo && !paper().latestScreeningRun!.screeningTwo!.passed"
                      [class.screening--manuel-sucess]="paper().latestScreeningRun!.manuelOverrideScreeningTwo !== null && paper().latestScreeningRun!.manuelOverrideScreeningTwo"
                      [class.screening--manuel-failed]="paper().latestScreeningRun!.manuelOverrideScreeningTwo !== null && !paper().latestScreeningRun!.manuelOverrideScreeningTwo"
                      (click)="viewResults(false)"
            >
            <span>Full-Text screening:
              @if (paper().latestScreeningRun!.manuelOverrideScreeningTwo !== null) {
                @if (paper().latestScreeningRun!.manuelOverrideScreeningTwo) {
                  Manual passed
                } @else {
                  Manual failed
                }
                @if (paper().latestScreeningRun!.screeningTwo) {
                  /
                  @if (paper().latestScreeningRun!.screeningTwo!.passed) {
                    Academate passed
                  } @else {
                    Academate failed
                  }
                }
              } @else if (paper().latestScreeningRun!.screeningTwo) {
                @if (paper().latestScreeningRun!.screeningTwo!.passed) {
                  Passed
                } @else {
                  Failed
                }
              }
            </span>
            </mat-chip>
          }
        }
        @if (!hasNoPdfDownloaded()) {
          @if (editable()) {
            <mat-chip class="screening screening--no-file"
                      (click)="uploadFile()"
                      aria-label="No PDF found, or able to download, click here to upload"
                      matTooltip="No PDF found, or able to download, click here to upload"
            >
              <mat-icon matChipAvatar>upload</mat-icon>
              <span>PDF is unavailable. Upload it</span>
            </mat-chip>
          } @else {
            <mat-chip class="screening screening--no-file">
              <mat-icon matChipAvatar>download</mat-icon>
              <span>PDF is unavailable</span>
            </mat-chip>
          }

        }
      </mat-chip-set>
    }
  </mat-card-content>
</mat-card>

